// Thin PostHog wrapper. Initialises lazily and no-ops if the
// VITE_POSTHOG_KEY env var is missing, so the app stays usable
// before the key is configured.
import posthog from "posthog-js";

let initialized = false;
let enabled = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  const key = "phc_pin2JyCeZAFYXX4BvQuPmdE4WZ8AoisCoogSo2Utrmt9";
  const host = "https://us.i.posthog.com";

  if (!key) {
    // Silently disabled until a key is provided.
    return;
  }

  try {
    posthog.init(key, {
      api_host: host,
      capture_pageview: true,
      capture_pageleave: true,
      person_profiles: "identified_only",
      autocapture: false,
      disable_session_recording: true,
    });
    enabled = true;
  } catch (err) {
    console.warn("[analytics] init failed", err);
  }
}

export function trackEvent(event: string, props?: Record<string, unknown>) {
  if (!enabled) return;
  try {
    posthog.capture(event, props);
  } catch (err) {
    console.warn("[analytics] capture failed", err);
  }
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!enabled || !userId) return;
  try {
    posthog.identify(userId, traits);
  } catch (err) {
    console.warn("[analytics] identify failed", err);
  }
}

export function resetAnalytics() {
  if (!enabled) return;
  try {
    posthog.reset();
  } catch {
    // ignore
  }
}

// Canonical event names — keep in one place so dashboards stay consistent.
export const AnalyticsEvents = {
  OnboardingCompleted: "onboarding_completed",
  WorkoutStarted: "workout_started",
  WorkoutCompleted: "workout_completed",
  PaywallViewed: "paywall_viewed",
  PaywallConversion: "paywall_conversion",
} as const;
